import { isResourceDetailBookmark, isResourceDetailHighlight, isResourceDetailNotepad, isResourceDetailFolder, isResourceDetailImage, isResourceDetailVideo, isResourceDetailAudio } from './resourceDetailGuards.js';

const getResourceNamePlaceholder = (resource) => {
  if (isResourceDetailBookmark(resource)) {
    return "Untitled bookmark";
  }
  if (isResourceDetailHighlight(resource)) {
    return "Untitled webnote";
  }
  if (isResourceDetailNotepad(resource)) {
    return "Untitled note";
  }
  if (isResourceDetailFolder(resource)) {
    return "Untitled folder";
  }
  if (isResourceDetailImage(resource)) {
    return "Untitled image";
  }
  if (isResourceDetailVideo(resource)) {
    return "Untitled video";
  }
  if (isResourceDetailAudio(resource)) {
    return "Untitled audio";
  }
  return "Untitled file";
};

export { getResourceNamePlaceholder };
//# sourceMappingURL=getResourceTitle.js.map
